<template>
  <div class="organization-details-fields">
    <div class="grid-x row grid-margin-x">
      <div class="cell auto">
        <app-label required>Organization name</app-label>
        <app-input autocomplete="organization" :value="value.name" @input="setName" required />
      </div>
    </div>

    <div class="grid-x row grid-margin-x">
      <div class="cell auto">
        <app-label required>Address</app-label>
        <app-input autocomplete="address-line1" :value="address.line1" @input="setAddress('line1', $event)" required />
      </div>
      <div class="cell auto">
        <app-label>Address line 2</app-label>
        <app-input autocomplete="address-line2" :value="address.line2" @input="setAddress('line2', $event)" />
      </div>
    </div>

    <div class="grid-x row grid-margin-x">
      <div class="cell small-3">
        <app-label required>ZIP Code</app-label>
        <app-input autocomplete="postal-code" :value="address.postalCode" @input="setAddress('postalCode', $event)" required />
      </div>
      <div class="cell auto">
        <app-label required>City</app-label>
        <app-input autocomplete="address-level2" :value="address.city" @input="setAddress('city', $event)" required />
      </div>
    </div>

    <div class="grid-x row grid-margin-x">
      <div class="cell auto">
        <app-label required>Country</app-label>
        <app-select :options="countries" :value="address.country" @input="setAddress('country', $event)" required />
      </div>
    </div>
  </div>
</template>

<script>
import countriesData from '@/services/data/countries';
import utils from '@/services/utils/utils';

export const emptyAddress = () => ({
  line1: '',
  line2: '',
  city: '',
  postalCode: '',
  state: 'unavailable',
  country: null,
});

export default {
  name: 'organization-details-fields',

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      countries: utils.enumToOptions(countriesData),
    };
  },

  computed: {
    address() {
      return this.value.address || emptyAddress();
    },
  },

  methods: {
    setName(name) {
      this.$emit('input', { ...this.value, name });
    },
    setAddress(field, fieldValue) {
      this.$emit('input', {
        ...this.value,
        address: { ...this.address, [field]: fieldValue },
      });
    },
  },
};
</script>
